module.exports = __webpack_public_path__ + "static/img/Sheezel.214899d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Sheezel.jpg
// module id = 0a/X
// module chunks = 0